import React from 'react';
import styled from 'styled-components';
import filterIcon from '../../../asset/icon/filter.png';
import { UniversalCheckbox } from '../../../shared/component/UniversalCheckbox';
import { useAdminMaterialAliasStore } from '../../share/store/adminMaterialAliasStore';

const MaterialAliasFilterStation: React.FC = () => {
  const { unassignedOnly, setUnassignedOnly } = useAdminMaterialAliasStore();

  return (
    <FilterGroup>
      <FilterLabel>
        <UniversalCheckbox
          checked={unassignedOnly}
          onChange={(event) => setUnassignedOnly(event.target.checked)}
        />
        Unassigned only
      </FilterLabel>
    </FilterGroup>
  );
};

const FilterGroup = styled.div`
  height: 2vh;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FilterLabel = styled.label`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.color_Gray_04};
  user-select: none;
  cursor: pointer;
  ${({ theme }) => theme.typography.Body_04};
`;

export default MaterialAliasFilterStation;
